import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import './accordion.css';
interface Props {
	primaryCols: Array<any>;
	secondaryCols: Array<any>;
	row: any;
	uuid: any;
	handleClick?: any;
	background: string;
}
export default function AccordionView({
	primaryCols,
	secondaryCols,
	uuid,
	handleClick,
	row,
	background,
}: Props) {
	const [expanded, setExpanded] = React.useState(false);

	const handleChange = () => {
		setExpanded((prev) => !prev);
	};
	const onclickHandler = () => {
		if (handleClick) {
			handleClick(row.metadata);
		}
	};
	return (
		<Accordion
			expanded={expanded}
			onChange={handleChange}
			className="accordion-wrapper"
			sx={{ background }}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls={uuid + 'content'}
				id={uuid}
				onClick={onclickHandler}
			>
				{primaryCols.map((pcol, index) => {
					return (
						<Box
							className="header-item"
							key={index}
						>{`${row[pcol]}`}</Box>
					);
				})}
			</AccordionSummary>
			<AccordionDetails>
				{secondaryCols.map((scol, index) => {
					return (
						<Typography
							fontSize="14px"
							marginBottom="5px"
							key={index}
						>{`${scol} : ${
							row[scol] || 'Not Available'
						}`}</Typography>
					);
				})}
			</AccordionDetails>
		</Accordion>
	);
}
